<h5>Pubnub Subscribed Channels</h5>
<ul>
  <li *ngFor="let channel of subscribedChannels$ | async">{{ channel }}</li>
</ul>
